import React, { useState, useEffect } from 'react';
import './juja.css';

const ImageComponent = ({ imageData, contentType }) => {
  const dataUri = `data:${contentType};base64,${imageData}`;
  return <img src={dataUri} alt="Imag" />;
};

const Juja = () => {
  const [houses, setHouses] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch('http://localhost:3002/juja');
      if (!response.ok) {
        throw new Error('Failed to fetch houses');
      }
      const data = await response.json();
      setHouses(data);
    } catch (error) {
      console.error('Error fetching houses:', error);
    }
  };

  return (
    <div className="house-cards">
      <h2>Juja</h2>
      <div className="card-container">
        {houses.map((house, index) => (
          <div className="card" key={index}>
          <ImageComponent imageData={house.picture.data} contentType={house.picture.contentType} />
          <div className="card-body">
            <h3>{house.name}</h3>
            <p><strong>House Type:</strong> {house.type}</p>
            <p><strong>Rent Paid (ksh):</strong> {house.rent}</p>
            <p><strong>Location:</strong> {house.location}</p>
            <p><strong>Landlord's Contact:</strong> {house.owner_number}</p>
            <p><strong>Ammenities:</strong> {house.security_features}</p>
          </div>
        </div>
        
        ))}
      </div>
    </div>
  );
};

export default Juja;